<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <div style="display: flex">
        <div style="margin-right: 30px;"><i class="el-icon-arrow-left back" @click="goList()"></i>{{goods_name}}</div>
        <div>
          <el-input
            style="width: 200px;"
            v-model="keyword"
            placeholder="输入电话/名称/收货地址等">
          </el-input>
          <el-button @click="getList(2)">搜索</el-button>
          <el-button @click="getList()" style="margin-right: 30px;">重置</el-button>
        </div>
        <div>
          <el-button size="small" style="margin-right: 30px;" type="primary" @click="openUp">批量上传物流单号</el-button>
        </div>
        <div>
          <el-button type="danger" size="small" @click="showDialog2">导出订单</el-button>
        </div>
      </div>
    </base-header>
    <el-main>
      <el-table
        :data="goods_detail"
        height="100%"
        v-loading="tableLoading">
        <el-table-column v-for="item in table_column"
                         :key="item.index"
                         :prop="item.prop"
                         :label="item.label"
                         :align="item.align || 'center'"
                         :width="item.width">
        </el-table-column>
        <el-table-column label="收货地址" align="center" width="200">
          <template v-slot="scope">
            <el-popover
              placement="top"
              width="300"
              v-model="scope.row.visible">
              <el-input v-model="scope.row.addressInput" style="width: 240px;"></el-input>
              <span @click="changeAddress(scope.row)">确定</span>
              <div slot="reference">
                <span style="cursor: auto; color:black;">{{scope.row.receive_address}}</span>
                <i class="el-icon-edit"></i>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" width="150" label="物流公司">
          <template v-slot="scope">
            <el-autocomplete
              style="padding: 5px 0;"
              v-for="item in scope.row.express_list"
              :key="item.index"
              v-model="item.express_company"
              :fetch-suggestions="querySearch"
              size="mini"
              :disabled="scope.row.disabled"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="运单号">
          <template v-slot="scope">
            <div v-for="(item, index) in scope.row.express_list" :key="item.index" style="text-align: left;">
              <el-input
                style="padding: 5px 0;"
                class="input"
                v-model="item.express_number"
                size="mini"
                :disabled="scope.row.disabled"></el-input>
              <i
                v-if="scope.row.express_list.length > 1 && !scope.row.disabled"
                class="el-icon-delete"
                style="cursor: pointer;"
                @click="deleteExpresslist(scope.row, index)"></i>
              <i
                v-if="index === scope.row.express_list.length - 1 && !scope.row.disabled"
                class="el-icon-circle-plus"
                style="font-size: 18px; color: #409EFF; cursor: pointer; margin-left: 5px;"
                @click="addExpressList(scope.row)">
              </i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发货状态" align="center" width="180">
          <template v-slot="scope">
            <el-button
              :disabled="scope.row.button === '已发货'"
              size="mini"
              :type="scope.row.button === '确认发货' ? 'primary' : 'info'"
              @click="submitGood(scope.row, '确认发货')">{{scope.row.button}}</el-button>
            <span
              v-if="scope.row.order_status === 1"
              @click="goEdit(scope.row, '保存修改')"
              :key="flag">&emsp;{{scope.row.editText}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
      &emsp;&emsp;
      <el-button @click="goList()" type="primary">后退</el-button>
    </el-footer>
    <el-dialog  title="上传文件" :visible.sync="dialogVisible" width="400px">
      <el-upload
        ref="upload"
        :data="{token: this.token}"
        :action="uploadUrl"
        :file-list="fileList"
        :on-success="UploadResult"
        :before-upload="beforeUpload"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      </el-upload>
    </el-dialog>
    <el-dialog  title="导出订单" :visible.sync="dialogVisible2" width="400px">
      <el-radio-group v-model="orderAll" @change="changeDisabled">
        <el-radio :label="1">全部时间</el-radio>
        <el-radio :label="0">筛选订单</el-radio>
      </el-radio-group>
      <div style="margin-top: 20px;">
        <span style="color: black">开始时间：</span>
        <el-date-picker
          :disabled="orderDisabled"
          v-model="startTime"
          type="datetime"
          placeholder="选择开始时间"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div style="margin-top: 20px;">
        <span style="color: black">结束时间：</span>
        <el-date-picker
          :disabled="orderDisabled"
          v-model="endTime"
          type="datetime"
          placeholder="选择结束时间"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div style="margin-top: 20px;">
        <span style="color: black">订单状态：</span>
        <el-select v-model="orderStatus" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-button style="margin-top: 20px;" type="danger" size="mini" @click="downloadXLSX">导出</el-button>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from '../../../../mixins/page'

export default {
  name: 'GoodDetail',
  mixins: [pageMixin],
  data () {
    return {
      token: sessionStorage.token,
      goodsDetailUrl: this.getDomain() + 'bmgoods/get_goods_detail', // 商品详情
      submitUrl: this.getDomain() + 'bmgoods/send_goods', // 提交信息
      getExpressListUrl: this.getDomain() + 'bmgoods/get_express_list', // 获取邮政
      uploadUrl: this.getDomain() + 'bmgoods/set_express_more',
      changeAddressUrl: this.getDomain() + 'bmgoods/modify_order_address',
      getExcelUrl: this.getDomain() + 'bmorder/export_goods_order',
      goods_detail: [],
      tableLoading: true,
      flag: 1,
      bigFlag: 1,
      goods_name: undefined,
      downloadReady: true,
      aoa: [],
      merges: [],
      table_column: [
        {
          prop: 'rank',
          label: '序号',
          width: '50'
        },
        {
          prop: 'order_id',
          label: '订单号',
          width: '120'
        },
        {
          prop: 'pay_time',
          label: '付款时间'
        },
        {
          prop: 'cost_unit_price',
          label: '进货单价（元）',
          width: '110'
        },
        {
          prop: 'sale_unit_price',
          label: '成交单价（元）',
          width: '110'
        },
        {
          prop: 'client_gain',
          label: '团长收益（元）',
          width: '110'
        },
        {
          prop: 'quantity',
          label: '购买数量',
          width: '70'
        },
        {
          prop: 'consignee',
          label: '收货人',
          width: '70'
        },
        {
          prop: 'mobile',
          label: '联系电话',
          width: '100'
        },
        {
          prop: 'remarks',
          label: '买家备注'
        },
        {
          prop: 'client_id',
          label: '团长ID',
          width: '70'
        },
        {
          prop: 'user_id',
          label: '用户ID',
          width: '70'
        }
      ],
      expressItems: [],
      keyword: undefined,
      dialogVisible: false,
      dialogVisible2: false,
      orderAll: 1,
      startTime: undefined,
      endTime: undefined,
      orderStatus: 3,
      orderDisabled: true,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            picker.$emit('pick', date)
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      options: [{
        value: 0,
        label: '未发货'
      }, {
        value: 1,
        label: '已发货'
      }, {
        value: 2,
        label: '已完成'
      }, {
        value: 3,
        label: '全部'
      }],
      fileList: [],
      maxExpress: 1
    }
  },
  methods: {
    getList (type = 0) {
      if (!type) {
        this.keyword = undefined
        this.tableLoading = true
      } else {
        if (this.downloadReady) {
          this.downloadReady = false
        } else {
          return
        }
      }
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        good_id: this.$route.query.good_id,
        type: type === 1 ? 1 : 0,
        keyword: type === 2 ? this.keyword : undefined
      }
      let handle = res => {
        this.totalCount = res.data.content.goods_data.order_count
        if (type === 0 || type === 2) {
          this.goods_detail = res.data.content.data
          this.handleList(this.goods_detail)
        }
        this.goods_name = res.data.content.goods_data.goods_name
      }
      let loadings = () => {
        this.tableLoading = false
      }
      if (!this.orderAll) {
        if (!this.startTime || !this.endTime) {
          this.$message.warning('未选择时间')
          return
        }
        if (this.startTime > this.endTime) {
          this.$message.warning('开始时间晚于结束时间')
          return
        }
        params.start_time = Math.floor(this.startTime.getTime() / 1000)
        params.end_time = Math.floor(this.endTime.getTime() / 1000)
        params.order_status = this.orderStatus === 3 ? undefined : this.orderStatus
      }
      this.__axios(this.goodsDetailUrl, params, handle, loadings)
    },
    handleList (list) {
      list.forEach(item => {
        this.$set(item, 'addressInput', '')
        this.$set(item, 'visible', false)
        item.pay_time = this.timeTransform(item.pay_time)
        item.cost_unit_price = item.cost_unit_price / 100
        item.sale_unit_price = item.sale_unit_price / 100
        item.client_gain = item.client_gain / 100
        item.disabled = !!item.order_status
        item.button = item.order_status === 0 ? '确认发货' : '已发货'
        item.editText = '编辑'
        if (!item.express_list.length) {
          item.express_list = [
            {
              express_number: undefined,
              express_company: undefined
            }
          ]
        }
      })
    },
    goList () {
      this.$router.push('/navmenu/GoodPlatform/good-list')
    },
    submitGood (row, message) {
      let params = {
        order_id: row.order_id,
        express_list: row.express_list
      }
      let handle = () => {
        this.$message({
          type: 'success',
          message: '提交成功'
        })
        row.editText = '编辑'
        this.getList()
      }
      if (this.checkedExpress(row.express_list)) {
        this.$message.warning('物流公司或运单号不能为空')
        return
      }
      this.__confirm(`是否${message}?`, this.__axios, [this.submitUrl, params, handle])
    },
    goEdit (row, message) {
      if (row.editText === '保存') {
        this.submitGood(row, message)
        this.flag++
      } else if (this.goods_detail.some(item => item.editText === '保存')) {
        this.$message.warning('一次编辑一条')
      } else {
        row.disabled = false
        row.editText = '保存'
        this.flag++
      }
    },
    querySearch (queryString, cb) {
      let expressItems = this.expressItems
      let results = queryString ? expressItems.filter(this.createFilter(queryString)) : expressItems
      cb(results)
    },
    createFilter (queryString) {
      return (expressItem) => {
        return (expressItem.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    getExpressList () {
      let handle = res => {
        this.expressItems = res.data.content.content
        this.expressItems.forEach(item => {
          item.value = item.express_company
        })
      }
      this.__axios(this.getExpressListUrl, {}, handle)
    },
    openUp () {
      this.dialogVisible = true
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    UploadResult (response) {
      if (response.err_code) {
        this.$message.error(response.content.info || response.discription)
      } else if (response.err_code === 0) {
        this.$message.success(`成功上传${response.content.success_count}条`)
        this.dialogVisible = false
        this.getList()
      }
    },
    // 上传前检测
    beforeUpload (file) {
      // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type !== 'application/x-xls') {
      //   this.$message.error('请上传xlsx或xls格式')
      //   return false
      // }
      return true
    },
    changeAddress (row) {
      if (row.addressInput) {
        let params = {
          order_id: row.order_id,
          order_address: row.addressInput
        }
        let handle = () => {
          this.$message({
            type: 'success',
            message: '上传成功'
          })
          row.visible = false
          row.receive_address = row.addressInput
        }
        this.__axios(this.changeAddressUrl, params, handle)
      }
    },
    checkedExpress (list) {
      return list.some(item => { return !item.express_number || !item.express_company })
    },
    addExpressList (row) {
      if (!row.disabled) {
        row.express_list.push({
          express_company: undefined,
          express_number: undefined
        })
      }
    },
    deleteExpresslist (row, index) {
      if (!row.disabled) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          row.express_list.splice(index, 1)
        })
      }
    },
    downloadXLSX () {
      let params = {
        goods_id: this.$route.query.good_id
      }
      if (!this.orderAll) {
        if (!this.startTime || !this.endTime) {
          this.$message.warning('未选择时间')
          return
        }
        if (this.startTime > this.endTime) {
          this.$message.warning('开始时间晚于结束时间')
          return
        }
        params.start_time = Math.floor(this.startTime.getTime() / 1000)
        params.end_time = Math.floor(this.endTime.getTime() / 1000)
      }
      params.order_status = this.orderStatus === 3 ? undefined : this.orderStatus
      let handle = res => {
        window.open(res.data.content.url)
      }
      this.__axios(this.getExcelUrl, params, handle)
    },
    showDialog2 () {
      this.dialogVisible2 = true
    },
    changeDisabled (value) {
      this.orderDisabled = !!value
    }
  },
  mounted () {
    this.getList()
    this.getExpressList()
  }
}
</script>

<style scoped>
  .back {
    cursor: pointer;
  }
  .back:hover {
    color: #3a8ee6;
  }
  .input {
    width: 120px;
  }
  span {
    color: #3a8ee6;
    cursor: pointer;
  }
</style>
